export default "__VITE_ASSET__tZ0lMMRD__"